var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_306)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2006_306",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0H0.5V20H19.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2006_306)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2006_306",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0H0.5V20H19.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2006_306)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2006_306",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0.5H0.5V19.5H19.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2006_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5293 9.05182H11.6616C11.2057 9.05182 10.9492 8.79739 10.9492 8.34503C10.9492 6.46025 10.9492 4.57512 10.9492 2.68963C10.9492 1.42648 11.8674 0.507496 13.1283 0.504328C14.5256 0.501161 15.9231 0.501161 17.3208 0.504328C18.5722 0.507496 19.4924 1.4249 19.4956 2.67327C19.4999 4.07735 19.4999 5.48143 19.4956 6.88552C19.4924 8.12386 18.5732 9.04496 17.3367 9.04971C16.4016 9.05182 15.4654 9.05182 14.5293 9.05182ZM14.8694 7.78498C15.7003 7.78498 16.5312 7.78814 17.3621 7.78498C17.8603 7.78498 18.2279 7.42076 18.2294 6.92564C18.233 5.49446 18.233 4.06345 18.2294 2.63262C18.2294 2.13697 17.8592 1.77381 17.3631 1.77223C15.939 1.76906 14.5145 1.76906 13.0897 1.77223C12.5809 1.77223 12.2175 2.13644 12.2164 2.64529C12.2138 4.30697 12.2164 5.97075 12.2122 7.63084C12.2122 7.76492 12.2529 7.7892 12.3767 7.7892C13.2076 7.78128 14.0385 7.78498 14.8694 7.78498Z",
    fill: "#185A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44728 10.9512H8.33451C8.79201 10.9512 9.04852 11.2035 9.04852 11.6559C9.04852 13.547 9.04852 15.4386 9.04852 17.3308C9.04587 18.5702 8.12718 19.495 6.89116 19.495C5.48077 19.5003 4.07039 19.5003 2.66 19.495C1.42504 19.4908 0.505818 18.5665 0.502644 17.3308C0.499119 15.9267 0.499119 14.5228 0.502644 13.1191C0.506347 11.8718 1.42768 10.9549 2.67957 10.9517C3.60144 10.9464 4.52436 10.9512 5.44728 10.9512ZM5.11143 12.218C4.30064 12.218 3.48931 12.218 2.67852 12.218C2.12 12.218 1.76935 12.5722 1.76882 13.1344C1.76882 14.5328 1.76882 15.9309 1.76882 17.3287C1.76882 17.8755 2.12529 18.2313 2.6727 18.2318C4.07744 18.2339 5.48201 18.2339 6.8864 18.2318C7.42164 18.2318 7.78235 17.8734 7.78288 17.3408C7.78288 15.6855 7.78287 14.0307 7.78658 12.3753C7.78658 12.2449 7.7522 12.2133 7.62473 12.2143C6.78591 12.218 5.94867 12.218 5.11143 12.218Z",
    fill: "#185A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5483 10.9512C15.4649 10.9512 16.381 10.9512 17.2986 10.9512C18.5849 10.9538 19.4956 11.8675 19.4972 13.1571C19.4972 14.5348 19.4972 15.9124 19.4972 17.2901C19.4972 18.5892 18.5838 19.4976 17.2811 19.4987C15.9095 19.4987 14.5385 19.4987 13.1679 19.4987C11.8573 19.4987 10.9497 18.5871 10.9492 17.2727C10.9492 15.414 10.9492 13.5552 10.9492 11.6965C10.9492 11.1908 11.1915 10.9512 11.7018 10.9512H14.5483ZM12.2143 14.8889C12.2143 15.6983 12.2143 16.5093 12.2143 17.3218C12.2143 17.8803 12.5692 18.2318 13.1314 18.2323C14.5295 18.2323 15.9275 18.2323 17.3256 18.2323C17.8719 18.2323 18.2279 17.875 18.2289 17.3281C18.2289 15.9234 18.2289 14.5187 18.2289 13.1143C18.2289 12.5791 17.8709 12.217 17.3377 12.217C15.6828 12.217 14.0274 12.217 12.3725 12.2133C12.2424 12.2133 12.2106 12.2476 12.2112 12.3753C12.2175 13.212 12.2143 14.0491 12.2143 14.8868V14.8889Z",
    fill: "#185A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0519 5.44829C9.0519 6.41038 9.0519 7.37265 9.0519 8.3351C9.0519 8.80278 8.80067 9.05034 8.32837 9.05087C6.45608 9.05087 4.58397 9.05087 2.71204 9.05087C1.41413 9.05087 0.504964 8.13663 0.503906 6.83389C0.503906 5.46148 0.503906 4.09048 0.503906 2.72088C0.503906 1.41023 1.41466 0.503906 2.73002 0.503906H6.82367C8.14908 0.503906 9.05084 1.41075 9.0519 2.73988C9.05225 3.64251 9.05225 4.54531 9.0519 5.44829ZM7.7852 5.13158C7.7852 4.3076 7.7852 3.4831 7.7852 2.65912C7.7852 2.12599 7.42449 1.76916 6.88872 1.76811C5.48398 1.76811 4.07923 1.76811 2.67449 1.76811C2.12708 1.76811 1.77167 2.12388 1.77114 2.67126C1.77114 4.07605 1.77114 5.48066 1.77114 6.8851C1.77114 7.42139 2.12867 7.78244 2.6618 7.78244C4.31671 7.78244 5.97215 7.78244 7.62758 7.78614C7.75611 7.78614 7.78996 7.75447 7.7889 7.62778C7.78255 6.79536 7.78572 5.964 7.7852 5.13316V5.13158Z",
    fill: "#185A7D"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCath);
export default __webpack_public_path__ + "static/media/cath.59b4b69cf1576ce3c2f1549455cd7550.svg";
export { ForwardRef as ReactComponent };